module.exports = __webpack_public_path__ + "static/media/synagogue.187c060a.svg";